import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Builds_BuildResult } from '@/graphql/codegen/generated/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'coloredLeftBorder',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as { status: Builds_BuildResult }


const borderClass = computed(() => `border-${props.status.toLowerCase()}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "w-full h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([_unref(borderClass), "w-full border-solid border-l-2 h-full flex items-center z-50"])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }))
}
}

})